import styled from 'styled-components'

export const Heading = styled.p`
  margin: 0 0 16px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #757575;
  text-align: center;
`

export const Grid = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 24px;
`

export const PathCard = styled.button<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 220px;
  min-height: 148px;
  padding: 16px;
  border: 1px solid ${({ $selected }) => ($selected ? '#0669f5' : '#f0f0f0')};
  border-radius: 16px;
  background: ${({ $selected }) => ($selected ? '#f7fbff' : '#ffffff')};
  cursor: pointer;
  text-align: center;
  transition: border-color 200ms ease, background-color 200ms ease;

  &:hover {
    border-color: ${({ $selected }) => ($selected ? '#0669f5' : '#d9d9d9')};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 4px #002a6d3d, 0 1px 2px 0 #0e0e0e0a;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const Icon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  color: #0669f5;
  font-size: 20px;
`

export const Title = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #363636;
`

export const Hint = styled.span`
  max-width: 160px;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #757575;
`
